import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

function DownloadPage() {
  const { linkId } = useParams<{ linkId: string }>();
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    if (linkId && !redirecting) {
      setRedirecting(true);
      const workerUrl = `https://dzajdrop-api-prod.dzajdrop.workers.dev/d/${linkId}${window.location.search}`;
      window.location.href = workerUrl;
    }
  }, [linkId, redirecting]);

  if (!linkId) {
    return <div className="error">Invalid download link</div>;
  }

  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h3>Redirecting to download...</h3>
      <p>
        If you are not redirected automatically,{" "}
        <a
          href={`https://dzajdrop-api-prod.dzajdrop.workers.dev/d/${linkId}${window.location.search}`}
        >
          click here
        </a>
        .
      </p>
    </div>
  );
}

export default DownloadPage;
